import {withTranslation} from "react-i18next";
import {
    ArrowRightOutlined,LeftOutlined
} from '@ant-design/icons';
import "../ceiba.scss";
import {Button} from 'antd';
import {history} from '_helpers/history';
import luxs from "assets/img/LUX_SEÑALA.png";

import sombraHombre from "assets/img/avatar/silueta-hombre.png"
import sombraMujer from "assets/img/avatar/silueta-mujer.png"
import Headerbutton from "../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function StepCeibaFour(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t, i18n} =props;


    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }

    return (

      <div className={"containerStartCeibaTwo wrapper history"}>
          <div className={"insideCeiba boxed"}>
              <Headerbutton  saveAndContinue={saveAndContinue}  />
          </div>
          <div className={"container-history boxed"}>
              <img className={"character character--flip character--lux"} src={luxs} alt={""} />
              <img className={"character character--flip character--sombra"}  src={user.gender && user.gender ==="m" ? sombraHombre : user.gender ==="f" ? sombraMujer : sombraHombre} alt={""} />
              <div className={"container-dialogue"}>
                  <div className={"dialogue-content-text"}>
                      <p className={"dialogue-text"} dangerouslySetInnerHTML={{__html: t('ceiba.acompanya')}}></p>
                  </div>
                  <div className={"dialogue-buttons"}>
                      <div className="left margin-right-auto">
                          <Button
                            icon={<LeftOutlined />}
                            type={"link"}
                            onClick={() => props.goTo(3)}
                          >
                              {t("atras")}
                          </Button>
                      </div>
                      <div className="right">
                          <Button icon={<ArrowRightOutlined />}
                                  onClick={() => props.goTo(5)}
                                  type={"primary"}
                                  className="primaryButton"
                          >
                              {t("ceiba.vamos")}
                          </Button>
                      </div>
                  </div>
                  <p className={"dialogue-name"}>
                      <strong>LUX</strong>
                  </p>
              </div>
          </div>
        </div>

    )
}

export default withTranslation()(StepCeibaFour);
